import React, { Component } from 'react';
import { UpcomingAppointmentWidget, LatestResultsWidget, NotificationsWidget, MyJourneyWidget } from 'components';
import './styles.css';

export default class Dashboard extends Component {

  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  
  render() {
    const firstName = 'Joanne';
  
    return (
      <div className="dashboard">
        <h1>{`Good Afternoon, ${firstName}`}</h1>
        <div className="dashboard__content">
          <UpcomingAppointmentWidget />
          <LatestResultsWidget />
          <NotificationsWidget />
          <MyJourneyWidget />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.js